import ProductCard from './ProductCard';
import {Spinner} from "react-bootstrap";
import { useState, useEffect } from "react";

function ProductResults({
  products,
  selectedAsins,
  onToggleProduct,
  onToggleAll,
  isLoading,
  onViewAnalytics,
}) {

  const [detailsExpanded, setDetailsExpanded] = useState(() => {
    const saved = localStorage.getItem('dashboard.detailsExpanded');
    return saved === 'true';
  });

  useEffect(() => {
    localStorage.setItem(
      'dashboard.detailsExpanded',
      detailsExpanded
    );
  }, [detailsExpanded]);

  if (isLoading) {
    return <div className="p-5 my-4"><Spinner animation="grow" variant="secondary" size="sm"/><span className="visually-hidden">Loading...</span></div>;
  }

  if (!products.length) {
    return <div>No products found</div>;
  }

  const allSelected = selectedAsins.size === products.length;

  return (
    <div className="product-results">
      <div className="results-header">
        <label className="btn btn-light btn-sm me-2">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={onToggleAll}
            className="me-2"
          />
          Check all
        </label>

        <span className="results-selected">
          Selected: <b>{selectedAsins.size}</b> of <b>{products.length}</b>
        </span>
      </div>

      {selectedAsins.size > 0 && (
        <div className="analytics-sticky">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              onViewAnalytics();
            }}
          >
            <i className="fa-solid fa-chart-line me-2"></i>
            View analytics ({selectedAsins.size})
          </button>
        </div>
      )}

      <div className="products-list d-flex gap-2 pt-2 pb-3 mb-3">
        {products.map(product => (
          <ProductCard
            key={product.asin}
            product={product}
            isSelected={selectedAsins.has(product.asin)}
            onToggle={() => onToggleProduct(product.asin)}
            detailsExpanded={detailsExpanded}
            onToggleDetails={() => setDetailsExpanded(prev => !prev)}
          />
        ))}
      </div>
    </div>
  );
}

export default ProductResults;
